import { DateTime } from 'luxon'
import { useEffect } from 'react'
import { AddedServices, timeScheduleSlice } from '@/store/timeScheduleSlice'
import { selectedDaysSelector } from '@/store/timeScheduleSlice/selectors/selectedDaysSelector'
import { visibleTimeSchedulesSelector } from '@/store/timeScheduleSlice/selectors/visibleTimeSchedulesSelector'
import { getTimeScheduleKey } from '@/utils/timeSchedules'
import { useAppDispatch, useAppSelector } from '../store'

export function useSelectedDays(): void {
  const dispatch = useAppDispatch()

  const addedServices = useAppSelector(
    timeScheduleSlice.selectors.addedServices
  )
  const selectedDays = useAppSelector(timeScheduleSlice.selectors.selectedDays)
  const serviceDays = useAppSelector(selectedDaysSelector)
  const visibleTimeSchedules = useAppSelector(visibleTimeSchedulesSelector)

  useEffect(() => {
    const selectedDays = serviceDays.map((time) => {
      const isoDate = DateTime.fromSeconds(time, {
        zone: 'utc',
      }).toISODate()

      return DateTime.fromISO(isoDate).toJSDate().getTime()
    })
    dispatch(timeScheduleSlice.actions.setSelectedDays(selectedDays))
  }, [])

  useEffect(() => {
    const addedServicesKeys = Object.keys(addedServices)
    if (addedServicesKeys.length === 0) {
      return
    }

    const visibleTimeSchedulesKeys =
      visibleTimeSchedules.map(getTimeScheduleKey)

    const newServices = addedServicesKeys.reduce<AddedServices>((acc, key) => {
      if (visibleTimeSchedulesKeys.includes(key)) {
        acc[key] = {
          ...addedServices[key],
        }
      }
      return acc
    }, {})

    if (Object.keys(newServices).length !== addedServicesKeys.length) {
      dispatch(timeScheduleSlice.actions.setAddedServices(newServices))
    }
  }, [addedServices, visibleTimeSchedules, selectedDays])
}
